import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "notification-bar",
  "aria-live": "polite",
  "aria-atomic": "false"
}
const _hoisted_2 = ["onMouseenter", "onMouseleave"]
const _hoisted_3 = { class: "flex-grow-1 me-3" }
const _hoisted_4 = {
  key: 0,
  class: "fw-bolder text-gray-900 fs-6"
}
const _hoisted_5 = { class: "text-gray-700 fs-7" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      tag: "div",
      "enter-active-class": "animate__animated animate__fadeInRight animate__faster",
      "leave-active-class": "animate__animated animate__fadeOutRight animate__faster",
      "move-class": "notification-bar-move"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationBar.notifications, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(`notification-bar-toast d-flex align-items-start bg-light-${_ctx.colorByType[item.type]} border border-${_ctx.colorByType[item.type]} border-dashed rounded shadow-sm p-5 mb-3`),
            role: "alert",
            onMouseenter: ($event: any) => (_ctx.notificationBar.pause(item.id)),
            onMouseleave: ($event: any) => (_ctx.notificationBar.resume(item.id))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(`bi ${_ctx.iconByType[item.type]} fs-2 text-${_ctx.colorByType[item.type]} me-4 mt-1`)
            }, null, 2),
            _createElementVNode("div", _hoisted_3, [
              (item.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.message), 1),
              (item.action)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.action.to,
                    class: _normalizeClass(`btn btn-sm btn-light-${_ctx.colorByType[item.type]} mt-2`),
                    onClick: ($event: any) => (_ctx.notificationBar.dismiss(item.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.action.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-icon btn-sm btn-active-light ms-auto",
              "aria-label": "Cerrar notificación",
              onClick: ($event: any) => (_ctx.notificationBar.dismiss(item.id))
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "bi bi-x fs-3" }, null, -1)
            ]), 8, _hoisted_6)
          ], 42, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}